import React from "react"
import styled from "~/ui/styled"
import { Message } from "~models"
import { formatWechatVoiceTime } from "~utils"

interface Props {
  isPlaying: boolean
  message: Message
  playTime: string
  duration: string
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void
}

const WaveWrap = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`

const Bar = styled.div<{ $byMe?: boolean; $playing?: boolean; $delay?: number }>`
  width: 3px;
  height: 12px;
  background-color: ${({ theme, $byMe }) =>
    $byMe ? theme.colors.blockBackground : theme.colors.text};
  margin-right: 2px;
  border-radius: 2px;
  transform: scaleY(0.67);
  transform-origin: bottom;
  animation: ${({ $playing }) => ($playing ? "voice-bar-wave 0.8s ease-in-out infinite" : "none")};
  animation-delay: ${({ $delay = 0 }) => `${$delay}s`};

  @keyframes voice-bar-wave {
    0%,
    100% {
      transform: scaleY(0.5);
    }
    50% {
      transform: scaleY(1.33);
    }
  }
`

const Wave = ({ isPlaying, byMe }: { isPlaying: boolean; byMe?: boolean }) => {
  return (
    <WaveWrap style={byMe ? { marginLeft: 8 } : { marginRight: 8 }}>
      <Bar $byMe={byMe} $playing={isPlaying} $delay={0} />
      <Bar $byMe={byMe} $playing={isPlaying} $delay={0.15} />
      <Bar $byMe={byMe} $playing={isPlaying} $delay={0.3} />
    </WaveWrap>
  )
}

const ButtonWrap = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  font: inherit;
`

const Text = styled.span<{ $byMe?: boolean }>`
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme, $byMe }) => ($byMe ? theme.colors.textLight : theme.colors.text)};
`

const Voice: React.FC<Props> = ({
  isPlaying,
  message,
  playTime: _playTime,
  duration,
  onClick,
}) => {
  return (
    <ButtonWrap
      type="button"
      onClick={(e) => {
        e.stopPropagation()
        onClick(e)
      }}
    >
      {message?.byMe ? (
        <>
          <Text $byMe={message?.byMe}>{formatWechatVoiceTime(duration)}</Text>
          <Wave byMe={message?.byMe} isPlaying={isPlaying} />
        </>
      ) : (
        <>
          <Wave byMe={message?.byMe} isPlaying={isPlaying} />
          <Text $byMe={message?.byMe}>{formatWechatVoiceTime(duration)}</Text>
        </>
      )}
    </ButtonWrap>
  )
}

export default Voice
